import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Input,
  Textarea,
} from "@chakra-ui/react";

import ExpertB2BDataService from "../../services/ExpertB2B";
import { useState, useEffect } from "react";

export const NoteB2BExpertModal = ({
  isOpen,
  onClose,
  id,
  func,
  existingNote,
}: any) => {
  const [note, setNote] = useState("");

  useEffect(() => {
    setNote(existingNote || "");
  }, [existingNote]);

  const handleDeleteNote = () => {
    ExpertB2BDataService.deleteNote(id)
      .then(() => {
        func(true);
        onClose();
      })
      .catch((e: Error) => {
        console.log(e);
      });
  };
  const handleAddEditNote = () => {
    const noteData = { note };
    ExpertB2BDataService.addEditNote(id, noteData)
      .then((response: any) => {
        func(true);
        onClose();
      })
      .catch((e: Error) => {
        console.log(e);
      });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{existingNote ? "Edit Note" : "Add Note"}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Textarea
            placeholder="Enter your note here..."
            value={note}
            onChange={(e) => setNote(e.target.value)}
          />
        </ModalBody>

        <ModalFooter>
          <Button
            bgColor="#327171"
            color="white"
            mr={3}
            onClick={handleAddEditNote}
          >
            {existingNote ? "Update Note" : "Add Note"}
          </Button>
          {existingNote && (
            <Button
              bgColor="red"
              color="white"
              mr={3}
              onClick={handleDeleteNote}
            >
              Delete
            </Button>
          )}
          <Button bgColor="gray" color="white" onClick={onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
